import { combineReducers } from "@reduxjs/toolkit";
import {authReducer, getUserByEmailReducer, 
    verifyEmailReducer,
    getUserReducer,
    resendVerifyEmailReducer,
    resetPasswordReducer,
    registerReducer,
    updatePassword,
    avatarPreviewReducer,
    updateProfileReducer,
     } from './authReducers'

import { getRoleReducer } from './roleReducers'
import {clientReducers} from './clientReducers'
import {subadminReducers} from './subadminReducers'
import {subscriptionReducers} from './subscriptionReducers'
import {adminReducers} from './adminReducers'
import {emailtemplateReducers} from "./emailtemplateReducers";
import {userDashboardReducers} from "./userDashboardReducers";
import {projectReducers} from "./projectReducers";
import {partnerReducers} from "./partnerReducers";
import {membersReducers} from "./membersReducers";
import {backgroundReducers} from "./backgroundReducers";
import {objectivesReducers} from "./objectivesReducers";
import {audiencesReducers} from "./audiencesReducers";
import {projectTimelinesReducers} from "./projectTimelinesReducers";
import { supportingDocsReducers } from "./supportingDocsReducers";
import {chatsReducers} from "./chatsReducers";

export default combineReducers({
    auth: authReducer,
    register: registerReducer,
    getUserByEmail: getUserByEmailReducer,
    verifyEmail: verifyEmailReducer,
    updatePassword: updatePassword,
    resendVerifyEmail: resendVerifyEmailReducer,
    resetPassword: resetPasswordReducer,
    getUser: getUserReducer,
    updateProfile: updateProfileReducer,
    getRole: getRoleReducer,
    avatarPreview: avatarPreviewReducer,
    emailtemplateReducers: emailtemplateReducers,

    clientStore: clientReducers,
    subadminStore: subadminReducers,
    subscriptionStore: subscriptionReducers,
    adminStore: adminReducers,
    userDashboardStore: userDashboardReducers,
    projectStore: projectReducers,
    partnerStore: partnerReducers,
    memberStore: membersReducers,
    backgroundStore: backgroundReducers,
    objectivesStore: objectivesReducers,
    audiencesStore: audiencesReducers,
    timelinesStore: projectTimelinesReducers,
    documentsStore: supportingDocsReducers,
    chatStore: chatsReducers,
});